import React from 'react';

import { AccountLink } from './AccountLink';
import * as styles from './AccountPopover.styles';
import { FAVOURITES_PAGE_HREF } from 'client-site-chrome-ui/constants/hrefs';

export const AnonymousAccountLinks = ({ includeFavourites }: { includeFavourites: boolean }) => (
  <div css={styles.sections}>
    <section>
      <h3 css={styles.title}>Returning customer?</h3>
      <AccountLink href="/u/sign-in" text="Sign in" />
    </section>
    <br />
    <section>
      <h3 css={styles.title}>New here?</h3>
      <AccountLink href="/u/register" text="Register" />
    </section>
    {includeFavourites && (
      <>
        <br />
        <section css={styles.smallScreensOnly}>
          <AccountLink href={FAVOURITES_PAGE_HREF} text="My Favourites" />
        </section>
      </>
    )}
  </div>
);
